import { EXHIBITOR_MENU_LIST } from "../../../utility/utility";
import React, { useContext, useState } from "react";
import { Badge, useTheme, useMediaQuery, LinearProgress } from "@mui/material";
import {
  IconButton,
  Drawer,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Collapse,
  Stack,
  Box,
  Typography,
} from "@mui/material";
import {
  Menu as MenuIcon,
  Dashboard as DashboardIcon,
  Explore as ExploreIcon,
  Map as FloorPlanIcon,
  BusinessCenter as ExhibitorServicesIcon,
  Book as CatalogueIcon,
  Favorite as FavoriteIcon,
  ExpandLess,
  ExpandMore,
} from "@mui/icons-material";
import ChatBubbleOutlineIcon from "@mui/icons-material/ChatBubbleOutline";
import NotificationsNoneIcon from "@mui/icons-material/NotificationsNone";
import "./DashHeader.css";
import MeetingRoomIcon from "@mui/icons-material/MeetingRoom";
import { UserContext } from "../../context/UserContext";
import AvatarMenu from "./AvatarMenu";
import { Link, useLocation } from "react-router-dom";
import useGetEventSettings from "../../hooks/useGetEventSettings";
import useApiEp from "../../../hooks/useApiEp";
const ExhibitorHeader = () => {
  const { pathname } = useLocation();
  const isOes = pathname.startsWith("/exhibitor/oes-forms");
  const theme = useTheme();
  const isLargeScreen = useMediaQuery(theme.breakpoints.up("sm"));
  const { user, loading } = useContext(UserContext);
  const { data: eD } = useGetEventSettings();
  const {
    data: notificationsCount,
    isLoading,
    isError,
    error,
  } = useApiEp(`/user/my-notifications-unseen-count`);
  // const unseenCount = notifications.reduce(
  //   (count, notification) => count + (!notification.seen ? 1 : 0),
  //   0
  // );

  const [drawerOpen, setDrawerOpen] = useState(false);
  const [exploreOpen, setExploreOpen] = useState(false);

  const toggleDrawer = (open) => () => {
    setDrawerOpen(open);
  };

  const handleExploreClick = () => {
    setExploreOpen(!exploreOpen);
  };

  if (loading) {
    return <LinearProgress />;
  }
  return (
    <div className="expp-dash-header-c">
      {isLargeScreen ? (
        <Link to={`/${user.role}`} style={{ textDecoration: "none" }}>
          {eD && (
            <Box sx={{ display: "flex", alignItems: "center", gap: 2, ml: 1 }}>
              <img
                src={eD?.eventLogo}
                alt="Event Logo"
                style={{
                  height: 74,
                  maxHeight: 74,
                  display: "block",
                  cursor: "pointer",
                  objectFit: "contain",
                }}
              />
              {eD?.eventName && (
                <Typography
                  variant="h5"
                  fontWeight={800}
                  color="#1e293b"
                  sx={{ letterSpacing: "-0.02em" }}
                >
                  {eD.eventName}
                </Typography>
              )}
            </Box>
          )}
        </Link>
      ) : (
        <IconButton
          onClick={toggleDrawer(true)}
          color="primary"
          aria-label="Open main navigation"
          aria-expanded={drawerOpen}
          size="large"
        >
          <MenuIcon fontSize="inherit" />
        </IconButton>
      )}

      <div style={{ flex: 1 }}></div>
      <Stack
        direction="row"
        spacing={1.5}
        alignItems="center"
        sx={{ mr: { xs: 1, md: 3 } }}
      >
        <Link to={`/${user.role}/chat`}>
          <IconButton
            sx={{
              backgroundColor: "#f1f5f9",
              color: "#3b82f6",
              transition: "all 0.2s ease-in-out",
              "&:hover": {
                backgroundColor: "#e0e7ff",
                transform: "scale(1.05)",
              },
              width: 42,
              height: 42,
            }}
          >
            <ChatBubbleOutlineIcon sx={{ fontSize: 20 }} />
          </IconButton>
        </Link>
        <Link to={`/${user.role}/my-notifications`}>
          <IconButton
            sx={{
              backgroundColor: "#f1f5f9",
              color: "#0ea5e9",
              transition: "all 0.2s ease-in-out",
              "&:hover": {
                backgroundColor: "#e0f2fe",
                transform: "scale(1.05)",
              },
              width: 42,
              height: 42,
            }}
            aria-label="notifications"
          >
            <Badge
              badgeContent={notificationsCount ? notificationsCount.count : 0}
              color="error"
              sx={{ "& .MuiBadge-badge": { fontWeight: 700 } }}
            >
              <NotificationsNoneIcon sx={{ fontSize: 22 }} />
            </Badge>
          </IconButton>
        </Link>
        <AvatarMenu />
      </Stack>

      <Drawer anchor="left" open={drawerOpen} onClose={toggleDrawer(false)}>
        <List>
          <ListItem
            button
            component={Link}
            to="/exhibitor"
            onClick={toggleDrawer(false)}
          >
            <ListItemIcon>
              <DashboardIcon />
            </ListItemIcon>
            <ListItemText primary="Dashboard" />
          </ListItem>
          <ListItem button onClick={handleExploreClick}>
            <ListItemIcon>
              <ExploreIcon />
            </ListItemIcon>
            <ListItemText primary="Explore" />
            {exploreOpen ? <ExpandLess /> : <ExpandMore />}
          </ListItem>
          <Collapse in={exploreOpen} timeout="auto" unmountOnExit>
            <List component="div" disablePadding>
              {EXHIBITOR_MENU_LIST[1].sublinks.map((item) => (
                <ListItem
                  key={item.link}
                  button
                  component={Link}
                  to={item.link}
                  onClick={toggleDrawer(false)}
                  sx={{ pl: 4 }}
                >
                  <ListItemText primary={item.label} />
                </ListItem>
              ))}
            </List>
          </Collapse>
          <ListItem
            button
            component={Link}
            to="/exhibitor/floor-plan"
            onClick={toggleDrawer(false)}
          >
            <ListItemIcon>
              <FloorPlanIcon />
            </ListItemIcon>
            <ListItemText primary="Floor Plan" />
          </ListItem>
          <ListItem
            button
            component={Link}
            to="/exhibitor/meetings"
            onClick={toggleDrawer(false)}
          >
            <ListItemIcon>
              <MeetingRoomIcon />
            </ListItemIcon>
            <ListItemText primary="Meetings" />
          </ListItem>
          <ListItem
            button
            component={Link}
            to="/exhibitor/leads"
            onClick={toggleDrawer(false)}
          >
            <ListItemIcon>
              <MeetingRoomIcon />
            </ListItemIcon>
            <ListItemText primary="Leads" />
          </ListItem>
          <ListItem
            button
            component={Link}
            to="/exhibitor/oes-forms"
            selected={isOes}
            aria-current={isOes ? "page" : undefined}
            onClick={toggleDrawer(false)}
          >
            <ListItemIcon>
              <ExhibitorServicesIcon />
            </ListItemIcon>
            <ListItemText primary="Exhibitor Services" />
          </ListItem>
          <ListItem
            button
            component={Link}
            to="/exhibitor/exhibition-catalogue"
            onClick={toggleDrawer(false)}
          >
            <ListItemIcon>
              <CatalogueIcon />
            </ListItemIcon>
            <ListItemText primary="Exhibition Catalogue" />
          </ListItem>
          <ListItem
            button
            component={Link}
            to="/exhibitor/favorites"
            onClick={toggleDrawer(false)}
          >
            <ListItemIcon>
              <FavoriteIcon />
            </ListItemIcon>
            <ListItemText primary="Favorites" />
          </ListItem>
        </List>
      </Drawer>
    </div>
  );
};

export default ExhibitorHeader;
